import { ReactNode } from "react";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { theme } from "../styles/theme";
import { GlobalStyleProvider } from "../styles/GlobalStyleProvider";

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  return (
    <StyledThemeProvider theme={theme}>
      <GlobalStyleProvider>{children}</GlobalStyleProvider>
    </StyledThemeProvider>
  );
};
